import React from "react";
import { Link } from "react-router-dom";
import { FaFilePdf } from "react-icons/fa6";

import File1 from "./../../assets/pdf/stub-order.pdf";
import File2 from "./../../assets/pdf/GuidelinesOfStrawManagementScheme.pdf";
import Video1 from "./../../assets/pdf/Agri-Minister-Hry-Message.mp4";
import Audio1 from "./../../assets/pdf/stubble-burning-audio.mpeg";
import Pic1 from "./../../assets/img/happy-seeder-zerotil-seed-cum-feretilizer-drill_1.jpg";
import Pic2 from "./../../assets/img/mulcher-reversible-plou.jpg";
import Pic3 from "./../../assets/img/crop-residue-management-measures.jpg";

const AntiStubbleBuringCampaign = () => {
  return (
    <div className="container my-3">
      <div className="abouts">
        <h5>Anti Stubble Buring Campaign</h5>
      </div>

      <div
        className="about-box p-4 rounded shadow-lg "
        style={{ textAlign: "justify" }}
      >
        <div className="table-responsive">
          <table className="table table-striped table-bordered">
            <thead>
              <tr>
                <th>
                  <span>S.No</span>
                </th>
                <th>
                  <span>Subject</span>
                </th>

                <th>
                  <span>
                    Document{" "}
                    <span style={{ fontSize: "12px" }}>(pdf, English)</span>
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <span>1</span>
                </td>
                <td>
                  <strong>
                    New Scheme namely Promotion of Agricultural Mechanism for
                    IN-SITU Management of Crop Residue
                  </strong>
                </td>

                <td className="text-center align-middle">
                  <Link to={File1} target="_blank">
                    <FaFilePdf style={{ fontSize: "25px" }} />{" "}
                  </Link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="row mb-1 justify-content-between">
          <div className="col-lg-12 mb-1">
            <div className="row mb-1 justify-content-between">
              <div className="col-lg-6 mt-2">
                <video controls width="100%">
                  <source src={Video1} type="audio/mp4" />
                </video>
              </div>
              <div className="col-lg-6 mt-2 text-center align-middle">
                <audio controls>
                  <source src={Audio1} type="audio/mpeg" /> Your browser does
                  not support the audio tag.
                </audio>
              </div>
            </div>
          </div>
          <div className="col-lg-12 my-1">
            <img 
              src={Pic1}
              alt="Seed Production"
              className="img-fluid rounded shadow-sm mt-2"
            />
            <img
              src={Pic2}
              alt="Seed Production"
              className="img-fluid rounded shadow-sm mt-3"
            />
            <img
              src={Pic3}
              alt="Seed Production"
              className="img-fluid rounded shadow-sm mt-3"
            />
          </div>
        </div>
        <div className="table-responsive mt-3">
          <table className="table table-striped table-bordered">
            <thead>
              <tr>
                <th>
                  <span>S.No</span>
                </th>
                <th>
                  <span>Subject</span>
                </th>

                <th>
                  <span>
                    Document{" "}
                    <span style={{ fontSize: "12px" }}>(pdf, English)</span>
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <span>1</span>
                </td>
                <td>
                  <strong>
                  Guidelines of Straw Management Scheme.
                  </strong>
                </td>

                <td className="text-center align-middle">
                  <Link to={File2} target="_blank">
                    <FaFilePdf style={{ fontSize: "25px" }} />{" "}
                  </Link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>
  );
};

export default AntiStubbleBuringCampaign;
